import PropTypes from 'prop-types';
import React from 'react';

// A titled "Well" section: the repeated `<div className="Well {modifier}"><h3>..</h3>`
// wrapper used to group related form fields (e.g. in lab-edit).
export const FieldGroup = ({ className, title, children }) => (
    <div className={`Well ${className}`}>
        <h3>{title}</h3>
        {children}
    </div>
);

FieldGroup.propTypes = {
    className: PropTypes.string,
    title: PropTypes.node,
    children: PropTypes.node,
};
